import { Component } from '@angular/core';
import { StorageService, ApiService, SnackbarService, UserInfoService, AuthService } from 'src/services';

import { Res } from 'src/models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-googlelogin',
  templateUrl: './googlelogin.component.html',
  styleUrls: ['./googlelogin.component.scss']
})
export class GoogleloginComponent {

  loading: boolean = false;
  private readonly redirectStorageKey = 'google_login_credential';

  constructor(
    private apiService: ApiService,
    private snackbarService: SnackbarService,
    private storage: StorageService,
    private userInfoService: UserInfoService,
    private authService: AuthService,
  ) {
  }

  ngOnInit() {
    const consumedRedirectCredential = this.consumeRedirectCredential();
    if (consumedRedirectCredential) {
      return;
    }

    // 已有登录态时不需要重新初始化 Google 按钮。
    if (this.authService.token) {
      return;
    }

    // crossOriginIsolated 页面主要用于 wasm，不再在这里初始化 GIS 按钮，
    // 否则会在进入 /nesting 这类隔离页面时出现误报提示。
    if (window.crossOriginIsolated) {
      return;
    }

    this.initializeGoogleSignIn();
  }

  initializeGoogleSignIn() {
    const buttonElement = document.getElementById('google-signin-button');
    if (!buttonElement) {
      return;
    }

    if (!(window as any).google?.accounts?.id) {
      console.warn('Google Identity Services script is unavailable.');
      return;
    }

    if (!environment.googleClientId) {
      this.snackbarService.open("Google Client ID 未配置");
      return;
    }

    (window as any).google.accounts.id.initialize({
      client_id: environment.googleClientId,
      ux_mode: 'redirect',
      login_uri: `${window.location.origin}/google-login-callback`,
    });

    // 渲染登录按钮
    (window as any).google.accounts.id.renderButton(
      buttonElement,
      { theme: 'outline', size: 'large' }
    );
  }

  // 处理登录成功后的回调
  handleCredentialResponse(response: any) {
    const token = response.credential;
    // 可选择将 token 发到服务器验证，或者直接在前端使用
    this.googleLogin(token);
    localStorage.setItem('google_token', token);
  }

  private consumeRedirectCredential(): boolean {
    const token = this.storage.getItem(this.redirectStorageKey);
    if (!token) return false;

    this.storage.removeItem(this.redirectStorageKey);
    localStorage.setItem('google_token', token);
    this.googleLogin(token);
    return true;
  }

  async googleLogin(token: string) {
    await this.withLoading(async () => {
      const body = { token: token, platform_id: 1 };
      const res: Res = await this.apiService["googleLogin"](body);
      if (res.status !== 'success') throw res;
      await this.authService.loginSuccess(res.result);
      await this.authService.refreshWasmToken();
      this.snackbarService.open("登录成功"); // 使用服务
    });
  }

  async withLoading(asyncFunc: () => Promise<any>) {
    try {
      this.loading = true;
      await asyncFunc();
    } catch (error: any) {
      console.log(error)
      this.snackbarService.open("something went wrong!"); // 使用服务
    } finally {
      this.loading = false;
    }
  }

}
